import { cloneDeep } from 'lodash';

import { SerializableObject } from '../../generic/serialization/serializable-object';
import { SerializableObjectSchema } from '../../generic/serialization/serializable-object-schema';

import { ConversationSpamDetectionConfigConstructor } from './conversation-spam-detection-config-constructor';
import { ConversationSpamDetectionConfigSchema } from './conversation-spam-detection-config-schema';

export class ConversationSpamDetectionConfig extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected enabled!: boolean;

  protected instructions!: string;

  protected spamDetectedMessage!: string;

  protected spamFilteringPassedMessage!: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: ConversationSpamDetectionConfigConstructor) {
    super(parameters);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): ConversationSpamDetectionConfig {
    return new ConversationSpamDetectionConfig(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(ConversationSpamDetectionConfig.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new ConversationSpamDetectionConfigSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getEnabled(): boolean {
    return cloneDeep(this.enabled);
  }

  public getInstructions(): string {
    return cloneDeep(this.instructions);
  }

  public getSpamDetectedMessage(): string {
    return cloneDeep(this.spamDetectedMessage);
  }

  public getSpamFilteringPassedMessage() {
    return cloneDeep(this.spamFilteringPassedMessage);
  }
}
